export const VERSION = Date.now();
